/**
 * Duplicate the selected front design onto the back.
 */

/**
 * @param {Array<Record<string, unknown>>} designs
 */
function hasOkSelectedFront(designs) {
    return (designs || []).some(
        (design) => design.side === 'front'
            && design.generation_status === 'ok'
            && design.is_selected
            && design.preview_url,
    );
}

/**
 * @param {HTMLElement} root
 * @param {{ getState: () => Record<string, unknown> }} store
 * @param {() => Promise<void>} onCopy
 */
export function bindCopyToBack(root, store, onCopy) {
    const btn = root.querySelector('#bag-copy-to-back-btn');
    const statusEl = root.querySelector('#bag-copy-to-back-status');

    if (!btn) {
        return {
            setStatus() {},
        };
    }

    btn.addEventListener('click', () => {
        if (btn.disabled) {
            return;
        }
        btn.disabled = true;
        setStatus('Copying front design to the back…', false);
        onCopy()
            .catch((err) => {
                setStatus(err && err.message ? err.message : 'Could not copy to the back.', true);
            })
            .finally(() => {
                syncEnabled(store.getState());
            });
    });

    store.subscribe((state) => {
        syncEnabled(state);
    });

    syncEnabled(store.getState());

    /**
     * @param {Record<string, unknown>} state
     */
    function syncEnabled(state) {
        const ready = hasOkSelectedFront(/** @type {Array<Record<string, unknown>>} */ (state.designs || []));
        // Global busy lock: another panel holds a mutation in flight.
        btn.disabled = Boolean(state.busy) || !ready;
        btn.title = ready
            ? 'Duplicate the front design onto the back. Each side stays independent.'
            : 'Generate a front design first.';
    }

    /**
     * @param {string} message
     * @param {boolean} isError
     */
    function setStatus(message, isError) {
        if (!statusEl) {
            return;
        }
        statusEl.textContent = message;
        statusEl.classList.toggle('text-danger', isError);
        statusEl.classList.toggle('text-muted', !isError);
    }

    return { setStatus };
}
